import React from "react";
import { Stack, Toolbar, Typography } from "@mui/material";

import { HubButton } from "../inputs";

export const HubToolbar = ({
  label = "",
  subtitle = "",
  onClose = () => {},
  buttonProps = {},
  stackProps = {},
  direction = "right",
  ...rest
}) => {
  const orientation = direction === "right" ? "end" : "start";
  return (
    <Toolbar variant="transparent" {...rest}>
      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent={orientation}
        onClick={onClose}
        gap="10px"
      >
        {orientation === "start" && (
          <HubButton
            variant="text"
            color="neutral"
            icon="ChevronLeft"
            onClick={onClose}
            sx={{ color: "hubColors.grey" }}
            {...buttonProps}
          />
        )}
        <Stack alignItems={orientation} {...stackProps}>
          {label && (
            <Typography variant="h6" sx={{ fontSize: 16 }} noWrap>
              {label}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="caption" sx={{ color: "hubColors.grey" }}>
              {subtitle}
            </Typography>
          )}
        </Stack>
        {orientation === "end" && (
          <HubButton
            variant="text"
            color="neutral"
            icon="ChevronRight"
            onClick={onClose}
            sx={{ color: "hubColors.grey" }}
            {...buttonProps}
          />
        )}
      </Stack>
    </Toolbar>
  );
};

export default HubToolbar;
